'use client';

interface DatePickerProps {
  value: string;
  onChange: (date: string) => void;
  label?: string;
}

export const DatePicker = ({ value, onChange, label = 'Snapshot Date' }: DatePickerProps) => {
  const id = `date-picker-${label.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div className='flex items-center space-x-2'>
      <label htmlFor={id} className='text-sm font-medium text-gray-700'>
        {label}:
      </label>
      <input
        id={id}
        type='date'
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className='border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500'
      />
    </div>
  );
};
